import type { FC } from 'react';

import type { TContainer } from '@/lib/interfaces/units/container.types';
import cn from '@/lib/packages/cn';

const Container: FC<TContainer> = ({ children, className }) => {
  return <div className={cn('relative mx-auto max-w-[90rem] px-4 sm:px-6 lg:px-8 min-h-0', className)}>{children}</div>;
};

export default Container;
